import React from 'react'
import FuelCreditSection from './FuelCreditSection'
import InfoSection from './InfoSection'
import PropTypes from 'prop-types'
import { Button, Checkbox } from 'loyal-react'

const Sidebar = ({
  creditName,
  creditValue,
  pointsValue,
  handlerFinalizePayment,
  loadingPayment,
  acceptTerms,
  acceptTermsEvent,
  showTermsEvent,
  handlerFormatValue,
  currencyConfiguration
}) => (
  <div className='cart-side col-12 col-md-4 mt-3 mt-md-0 border-ui-3 radius bg-white px-0 py-0'>
    <div className='col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
      <h3 className='color-title txt-font-body'>Resumo do resgate</h3>
    </div>
    <div className='cart-subtotal col-12 pb-3 mx-0'>
      <div className='row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'>
        <FuelCreditSection
          creditName={creditName}
          creditValue={creditValue.split(' ')[0]}
          pointsValue={`${handlerFormatValue(
            pointsValue,
            currencyConfiguration.decimalPlaces
          )} ${currencyConfiguration.pointsName}`}
        />
      </div>
      <div className='row product-brand pt-3  px-2'>
        <InfoSection />
        <div className='col-12'>
          <div className='row mx-0 h-100 align-items-center'>
            <Checkbox
              style={{ position: 'relative', marginLeft: '20px' }}
              id='aceito_termos'
              checked={acceptTerms}
              className='col-auto'
              labelClass='l-0'
              outerLabel
              onChange={e => acceptTermsEvent(e.target.checked)}
            />
            <div className='col-auto'>
              <p className='txt-body-sm'>
                Li e aceito os{' '}
                <a
                  onClick={e => showTermsEvent()}
                  className='txt-body-sm color-brand-2 txt-underline'
                  role='button'
                >
                  termos do regulamento
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='cart-done row  px-2 pt-2 '>
        <div className='col-12 justify-content-center align-self-center'>
          {loadingPayment ? (
            <button
              className='btn-featured btn-icon'
              aria-label='Carregando...'
            >
              <div className='btn-loading mr-auto ml-auto'>
                <div />
                <div />
                <div />
                <div />
              </div>
            </button>
          ) : (
            <Button
              className='btn-featured btn-icon'
              disabled={validButton(
                creditName,
                creditValue,
                pointsValue,
                acceptTerms
              )}
              text='Finalizar compra'
              iconName='icon_gift'
              onClick={handlerFinalizePayment}
            />
          )}
        </div>
      </div>
    </div>
  </div>
)

const validButton = (creditName, creditValue, pointsValue, acceptTerms) => {
  const result = !!(creditName && creditValue && pointsValue && acceptTerms)

  return !result ? 'disabled' : ''
}

Sidebar.propTypes = {
  creditName: PropTypes.string,
  loadingPayment: PropTypes.bool,
  creditValue: PropTypes.number,
  pointsValue: PropTypes.number,
  handlerFinalizePayment: PropTypes.func,
  acceptTerms: PropTypes.bool,
  showTermsEvent: PropTypes.func,
  acceptTermsEvent: PropTypes.func,
  handlerFormatValue: PropTypes.func,
  currencyConfiguration: PropTypes.object
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/features/FuelCredit/Sidebar/Sidebar.js